import { css, html, LitElement } from 'lit-element';
import { safeDefine } from 'lm-ui-kit/src/utils/define-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { largeDesktop } from '../utils';

class UcAdeoLink extends LitElement {
  static styles = css`
    :host {
      --img-width: auto;

      position: relative;
      display: flex;
      width: auto;
      height: 100%;
    }

    :host([adeo]) {
      --img-height: ${pxToRem(33)};
      --img-width: ${pxToRem(56)};
    }

    :host([shops]) {
      --img-height: ${pxToRem(29)};
      --img-width: ${pxToRem(53)};

      width: 100%;

      background-color: #e4e4e4;
    }

    .container {
      --button-color: #666;

      width: 100%;
    }

    .content {
      display: flex;
      width: 100%;
      height: 100%;
    }

    .content::slotted(uc-image) {
      position: absolute;
      top: calc(50% - var(--img-height) / 2);
      left: ${pxToRem(8)};
    }

    .content::slotted(a) {
      z-index: 1;
      width: 100%;
      height: 100%;
      padding: ${pxToRem(16)} ${pxToRem(10)} ${pxToRem(16)};

      font-size: ${pxToRem(10)};
    }

    ${largeDesktop(css`
      :host([shops]) {
        max-width: initial;
      }

      .content::slotted(a) {
        font-size: ${pxToRem(13)};
      }
    `)}
  `;

  render() {
    return html` <uc-button class="container"><slot class="content"></slot></uc-button> `;
  }
}

safeDefine('uc-adeo-link', UcAdeoLink);
